<template>
  <div>
    default
    <sj-card style="padding: 10px;">
      <SjBaseTable
        :columns="columnsSimple2"
        :data="dataSimple2"
        :tableProps="tableProps2"
        @filter-change="handleFilterChange"
      >
      </SjBaseTable>
    </sj-card>
    <div style="height: 5px;"></div>

    medium
    <sj-card style="padding: 10px;">
      <SjBaseTable
        :columns="columnsSimple2"
        :data="dataSimple2"
        :tableProps="tableProps"
        size="medium"
      >
      </SjBaseTable>
    </sj-card>
    <div style="height: 5px;"></div>
    small
    <sj-card style="padding: 10px;">
      <SjBaseTable
        :columns="columnsSimple2"
        :data="dataSimple2"
        :tableProps="tableProps"
        size="small"
      >
      </SjBaseTable>
    </sj-card>
    <div style="height: 5px;"></div>
    <sj-card style="padding: 10px;">
      <SjBaseTable
        :columns="columnsSimple2"
        :data="[]"
        :tableProps="tableProps"
      >
      </SjBaseTable>
    </sj-card>
    <div style="height: 5px;"></div>
  </div>
</template>

<script>
import CustomEle from "./CustomEle";
export default {
  data() {
    return {
      tableProps: {
        "highlight-current-row": true,
        "highlight-hover": true,
        defaultSelection: 0,
        maxHeight: 300,
        stripe: false,
        cellClassName({ rowIndex, columnIndex }) {
          return `row${rowIndex}$column${columnIndex}`;
        },
        headerStyles({ columnIndex }) {
          if (columnIndex === 0)
            return {
              backgroundColor: "lightblue"
            };
          return {};
        },
        cellStyles({ columnIndex }) {
          if (columnIndex === 0)
            return {
              backgroundColor: "lightblue"
            };
          return {};
        }
      },
      tableProps2: {
        maxHeight: 300,
        "highlight-current-row": true,
        "highlight-hover": false,
        stripe: false,
        border: true
      },
      columnsSimple2: [
        {
          prop: "name",
          label: "名称",
          fixed: true,
          width: 80
        },
        {
          prop: "row1",
          label: "列1",
          width: 300,
          filterable: true,
          sortable: true,
          filterPlaceholder: "大于",
          customFilter(key, data) {
            console.log("customfilter", key, data);
            return data > key;
          },
          renderHeader() {
            return <div>自定义表头</div>;
          },
          customRender: () => {
            const condition = Math.random() > 0.5 ? true : false;
            const data = [];
            data.push(<span>基本项目</span>);
            if (condition) {
              data.push(<span> 附加项目</span>);
            }
            return <div>{data}</div>;
          }
        },
        {
          prop: "row2",
          label: "列2",
          width: 300,
          filterable: "category",
          filterOptions: [
            { label: "清空", value: null },
            ...["天使轮", "A轮", "B轮", "C轮", "C+轮"].map(v => ({
              label: v,
              value: v
            }))
          ],
          customRender: (h, { row, column }) => (
            <CustomEle>custom render{row[column.prop]}</CustomEle>
          )
        },
        {
          prop: "row3",
          label: "列3",
          align: "center",
          width: 300,
          sortable: true,
          formatter(v) {
            return (v / 10).toFixed(1);
          }
        }
      ],
      dataSimple2: Array.from({ length: 10 }).map((v, i) => ({
        name: i,
        row1: Math.floor(Math.random() * 1000),
        row2: ["天使轮", "A轮", "B轮", "C轮", "C+轮"][
          Math.floor(Math.random() * 5)
        ],
        row3: Math.floor(Math.random() * 1000)
      }))
    };
  },
  methods: {
    handleCellClick(row, column) {
      console.log;
      if (column.property === "row1") {
        alert(JSON.stringify(row));
      }
    },
    handleFilterChange(filters) {
      console.log(arguments);
      this.$SjNotify({
        message: `过滤内容: ${Object.keys(filters)
          .map(v => {
            if (!filters[v]) return "";
            return `${v}: ${JSON.stringify(filters[v].key)}`;
          })
          .join(", ")}`,
        duration: 3000
      });
    },
    customFilter(data, filterConfig) {
      return data.filter(item =>
        Object.keys(filterConfig).every(
          key => !filterConfig[key] || item[key] > filterConfig[key]
        )
      );
    }
  }
};
</script>

<style scoped lang="less"></style>
